// extracted by mini-css-extract-plugin
export default {"cancel-btn":"QrCodePay_cancel-btn__pJDEl","title":"QrCodePay_title__tUTkt","amount":"QrCodePay_amount__sXnD4","hint":"QrCodePay_hint__yE3xa"};